<template>
  <div>
    <canvas
      :id="chart_id"
      :width="width"
      :height="height"
      :aria-label="chart_id"
      role="img"
      :responsive="false"
    ></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  mounted() {
    this.draw();
  },

  data() {
    return {
      chart_id: `chart-id-${Math.random(10)}`,
    };
  },

  props: {
    type: {
      required: true,
    },
    data: {
      default() {
        return [];
      },
    },
    options: {
      default() {
        return [];
      },
    },
    width: {
      default() {
        return 300;
      },
    },
    height: {
      default() {
        return `300px`;
      },
    },
    correlation: {
      default() {
        return true
      }
    }
  },

  methods: {
    draw() {
      let ctx = document.getElementById(this.chart_id);

      if(this.type == 'line' || this.type == 'bar') {
        new Chart(ctx, {
          type: this.type,
          data: this.data,
          options: {
            scales: {
              y: {
                beginAtZero: true,
                max: this.correlation ? 8 : null,
                min: this.correlation ? -8 : null,
              },
            },
            plugins: {
              legend: {
                  display: this.correlation ? false : true
              }
          }
          },
        });
      } else {
        new Chart(ctx, {
          type: this.type,
          data: this.data,
          options: {
            plugins: {
              legend: {
                  display: this.correlation ? false : true
              }
          }
          },
        });
      }
    },
  },
};
</script>
